export class BaseResponse {
    success?: boolean;
    message: string;
    data?: any;
    errors?: any;
    status?: number;
    response?: any;
}
